import { combineReducers } from '@reduxjs/toolkit';
import partnersReducer from '../features/PartnerManagement/slices/partnersSlice';
import transactionsReducer from '../features/PartnerManagement/slices/transactionsSlice';
import transactionManagementReducer from '../features/TransactionManagement/slices/transactionManagementSlice';
import membersReducer from '../features/MemberManagement/slices/membersSlice';

const partnerNetworkReducer = combineReducers({
  partners: partnersReducer,
  transactions: transactionsReducer,
  transactionManagement: transactionManagementReducer,
  members: membersReducer,
});

export default partnerNetworkReducer;